import {Box, Card, CardContent, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {PrettyPrintYMD} from './forms/fields/SeaService';
import {isObject} from 'utils/objects';

const useStyles = makeStyles(theme => ({
    jsonCard: {
        background: theme.palette.gray.light2,
        marginBottom: '1em',
    }
}));

const render = (fieldname, value, map, classes) => {
    if (value === undefined) {
        return null;
    } else if (fieldname === 'year_month_days_input_json') {
        return <PrettyPrintYMD data={JSON.stringify(value)} />;
        //nice displays for training cert courses data
    } else if (isObject(value)) {
        if (map) {
            return (
                <Card className={classes.jsonCard}>
                    <CardContent>
                    {Object.keys(map).map(key => {
                        const thisValue = value[key];
                        return thisValue !== null ? (
                            <Box>
                                <Typography variant='subtitle2' component='span'>{map[key]}: </Typography>
                                <Typography component='span'>{render(null, thisValue, map)}</Typography>
                            </Box>
                        ) : null
                    })}
                    </CardContent>
                </Card>
            )
        } else {
            // this really shouldn't be happening anymore
            console.warn('Warning, printing JSON to Review Screen', value, map);
            return JSON.stringify(value);
        }
    } else if (value === 'true' || value === true) {
        return 'Yes';
    } else if (value === 'false' || value === false) {
        return 'No';
    } else {
        return value;
    }
}

const PrintFieldValue = ({fieldname, value, map}) => {
    const classes = useStyles();
    // nice diplay for YMD sea service widget data
    if (Array.isArray(value)) {
        return value.map(item => render(fieldname, item, map, classes));
    }
    return render(fieldname, value, map, classes);
};

export default PrintFieldValue;
